import "css/style.css"
import {lazyLoading} from "js/lazyload/lazyload-init"
import "@components/main-nav"
import "@components/main-header/main-header"
import "./same-height/same-height"

window.lazyloading = lazyLoading // add lazyloading to global window object

async function loadFancybox() {
  await import("js/fancybox/fancybox-gallery-id-generator")
  if (document.querySelectorAll(".entry-content .kt-img-link, .entry-content a").length) {
    await import("@components/wordpress/entry-content/js/entry-content-fancybox-image")
  }
  if (document.querySelectorAll("[data-fancybox]").length) {
    await import("js/fancybox/fancybox")
  }
}
loadFancybox()

async function loadModals() {
  if (document.querySelectorAll(".c-modal").length) {
    await import("@components/modal/modal")
  }
}
loadModals()

async function loadFileInput() {
  if (document.querySelectorAll(".f-file").length) {
    await import("@components/fields/file-field/file-field")
  }
}
loadFileInput()

async function loadDateInput() {
  if (document.querySelectorAll(".f-date").length) {
    await import("@components/fields/date-field/date-field")
  }
}
loadDateInput()

async function loadPasswordField() {
  if (document.querySelectorAll(".f-text.--password").length) {
    await import("@components/fields/text-field/text-field--password")
  }
}
loadPasswordField()

async function loadCalendar() {
  if (document.querySelectorAll(".s-calendar").length) {
    await import("@components/sections/calendar-section/calendar-section")
  }
}
loadCalendar()

async function loadSlimSelect() {
  if (document.querySelectorAll(".slim-select").length) {
    await import("js/slim-select/slim-select")
  }
}
loadSlimSelect()

async function loadAlerts() {
  if (document.querySelectorAll(".i-alert").length) {
    await import("@components/items/alert-item/alert-item")
  }
}
loadAlerts()

async function loadNotification() {
  if (document.querySelectorAll(".i-notification").length) {
    await import("@components/items/notification-item/notification-item")
  }
}
loadNotification()

async function loadFaqItem() {
  if (document.querySelectorAll(".i-faq").length) {
    await import("@components/items/faq-item/faq-item")
  }
}
loadFaqItem()

async function loadSwiper() {
  if (document.querySelectorAll(".swiper").length) {
    await import("js/swiper/swiper")
    // AddEvent that informs about swiper initialization
    document.dispatchEvent(new Event("swipersInitialized"))
  }
}
loadSwiper()

async function loadCheckboxSelectField() {
  if (document.querySelectorAll(".f-checkbox-select").length) {
    await import("@components/fields/checkbox-select-field")
  }
}
loadCheckboxSelectField()

async function loadOverlayScrollbars() {
  if (document.querySelectorAll(".u-scrollbar").length) {
    await import("js/overlayscrollbars")
  }
}
loadOverlayScrollbars()

async function loadBaseForm() {
  if (document.querySelectorAll("form.--validate").length) {
    await import("@components/base-form/base-form")
    document.dispatchEvent(new Event("baseformInitialized"))
  }
}
loadBaseForm()

async function loadScrollUp() {
  if (document.querySelectorAll(".c-scroll-up").length) {
    await import("@components/scroll-up/scroll-up")
  }
}
loadScrollUp()

async function loadThemeConfig() {
  if (document.querySelectorAll(".c-theme-config").length) {
    await import("@components/theme-config/theme-config")
  }
}
loadThemeConfig()

async function loadTabs() {
  if (document.querySelectorAll(".js-tabs").length) {
    await import("js/tabs/tabs")
  }
}
loadTabs()

async function loadExternalSvgLoader() {
  if (document.querySelectorAll(".c-svg").length) {
    await import("@components/svg")
  }
}
loadExternalSvgLoader()

async function loadMenuItem() {
  if (document.querySelectorAll(".i-menu.--has-submenu").length) {
    await import("@components/items/menu-item/menu-item")
  }
}
loadMenuItem()

async function loadMainHeaderSearch() {
  if (document.querySelectorAll(".m-header-search").length) {
    await import("@components/main-header/main-header-search/main-header-search")
  }
}
loadMainHeaderSearch()

async function loadWordpressEntryContent() {
  if (document.querySelectorAll(".entry-content iframe").length) {
    await import("@components/wordpress/entry-content/js/entry-content-iframe")
  }
  if (document.querySelectorAll(".entry-content table").length) {
    await import("@components/wordpress/entry-content/js/entry-content-width-height")
  }
}
loadWordpressEntryContent()

async function loadWordpressMenuItem() {
  if (document.querySelectorAll(".menu-item-has-children, .page_item_has_children").length) {
    await import("@components/wordpress/items/menu-item/menu-item")
  }
}
loadWordpressMenuItem()

async function loadWordpressAside() {
  if (document.querySelectorAll(".widget_categories, .widget_nav_menu, .widget_pages").length) {
    await import("@components/wordpress/aside/aside")
  }
}
loadWordpressAside()

async function loadHoney() {
  if (document.querySelectorAll("input.js-honey").length) {
    await import("js/honey")
  }
}
loadHoney()

async function loadTextAndMediaSlider() {
  if (document.querySelectorAll(".g-text-and-media-slider").length) {
    await import("@components/groups/text-and-media-slider-group/text-and-media-slider-group")
  }
}
loadTextAndMediaSlider()

async function loadVideoSection() {
  if (document.querySelectorAll(".s-video__content").length) {
    await import("@components/sections/video-section/video-section")
  }
}
loadVideoSection()

async function loadProgramItem() {
  if (document.querySelectorAll(".i-program").length) {
    await import("@components/items/program-item/program-item")
  }
}
loadProgramItem()

async function loadUspsSlider() {
  if (document.querySelectorAll(".g-usps.--slider").length) {
    await import("@components/groups/usps-group/usps-group--slider")
  }
}
loadUspsSlider()

async function loadExpertiseSection() {
  if (document.querySelectorAll(".s-expertise__content").length) {
    await import("@components/sections/expertise-section/expertise-section")
  }
}
loadExpertiseSection()

async function loadScrollSectionDown() {
  if (document.querySelectorAll(".js-scroll-section-down").length) {
    await import("js/scroll-section-down/scroll-section-down")
  }
}
loadScrollSectionDown()

async function loadAccordionSection() {
  if (document.querySelectorAll(".s-accordion__content").length) {
    await import("@components/sections/accordion-section/accordion-section")
  }
}
loadAccordionSection()

async function loadTippy() {
  if (document.querySelectorAll(".tippy").length) {
    await import("js/tippy/tippy")
  }
}
loadTippy()

async function loadProgramCompareCareItem() {
  if (document.querySelectorAll(".i-program-compare-care-item").length) {
    await import("@components/items/program-compare-care-item/program-compare-care-item")
  }
}
loadProgramCompareCareItem()

async function loadProgramCompareSection() {
  if (document.querySelectorAll(".s-program-compare__content").length) {
    await import("@components/sections/program-compare-section/program-compare-section")
  }
}
loadProgramCompareSection()

async function loadHeroSlideItem() {
  if (document.querySelectorAll(".i-hero-slide").length) {
    await import("@components/items/hero-slide-item/hero-slide-item")
  }
}
loadHeroSlideItem()
